import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const TestimonialComponent = styled.div`
  margin: ${theme.spacing[8]} 0;
`;

export const TestimonialBox = styled.div``;

export const TestimonialText = styled.div`
  display: grid;
  grid-cols-1	grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: ${theme.spacing[4]};
`;

export const TestimonialQuote = styled.div`
  font-size: ${theme.fontSizes[3]};
  line-height: ${theme.leading.relaxed};
`;

export const TestimonialImageAndPerson = styled.div``;

export const TestimonialPersonText = styled.div``;

export const TestimonialName = styled.div`
  font-size: ${theme.fontSizes[2]};
`;

export const TestimonialTitle = styled.div`
  color: ${theme.colors.darkBlues[75]};
`;

export const TestimonalPersonImage = styled.img``;

export const TestimonialCompanyLogo = styled.div`
  max-height: 50px;

  .gatsby-image-wrapper {
    max-height: 50px;

    img {
      object-fit: contain !important;
    }
  }
`;
